<template>
  <div
    ref="frisbuy-widget-highlights"
    :class="{
      'frisbuy-sr-widget': true,
      'frisbuy-has-selected': selectedAlbum,
      'frisbuy-sr-right': settings.widget.rightSide == 1,
      'frisbuy-sr-mobile-fixed': settings.widget.mobileFixed == 1,
      'frisbuy-sr-inline':
        settings.widget.inlineDesktop == 1 ||
        (isMobileLandscape && !settings.widget.mobileFixed),
      'frisbuy-mobile-only': isMobileOnly,
      'frisbuy-desktop-only': isDesktopOnly,
    }"
    @transitionend="storiesScroll"
    :style="{
      paddingTop: paddings.top,
      paddingBottom: paddings.bottom,
      paddingLeft: paddings.left,
      paddingRight: paddings.right,
      backgroundColor: backgroundColor,
    }"
  >
    <div v-html="settings.customStyles" v-if="settings.customStyles"></div>
    <div
      class="frisbuy-title-block"
      v-html="settings.widget.html"
      v-if="settings.widget.html"
    ></div>
    <div :class="{ 'frisbuy-sr-block-wrapper': isArrowsDisplayed }">
      <div v-if="isArrowsDisplayed">
        <div class="frisbuy-sr-arrow" @click="slideHandler(-1)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 21L2 12L11 3"
              stroke="#2C2C2C"
              stroke-width="1.72"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 12H22"
              stroke="#2C2C2C"
              stroke-width="1.72"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="frisbuy-sr-arrow" @click="slideHandler(1)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 3L22 12L13 21"
              stroke="#2C2C2C"
              stroke-width="1.72"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 12L2 12"
              stroke="#2C2C2C"
              stroke-width="1.72"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <div
        v-show="!selectedAlbum || settings.widget.inlineDesktop == 1"
        class="frisbuy-sr-block"
      >
        <a
          v-if="!settings.censorship.hide_ig"
          :class="{
            'frisbuy-sr-instagram': true,
            'frisbuy-to-hide': canNavigatePrev,
          }"
        >
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.5 12h-15C17.598 12 12 17.598 12 24.5v15C12 46.403 17.598 52 24.5 52h15C46.403 52 52 46.403 52 39.5v-15C52 17.598 46.403 12 39.5 12zm8.75 27.5c0 4.825-3.925 8.75-8.75 8.75h-15c-4.825 0-8.75-3.925-8.75-8.75v-15c0-4.825 3.925-8.75 8.75-8.75h15c4.825 0 8.75 3.925 8.75 8.75v15z"
              fill="url(#ca)"
            />
            <path
              d="M32 22c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 16.25A6.26 6.26 0 0 1 25.75 32 6.257 6.257 0 0 1 32 25.75 6.257 6.257 0 0 1 38.25 32 6.26 6.26 0 0 1 32 38.25z"
              fill="url(#cb)"
            />
            <path
              d="M42.75 22.582a1.333 1.333 0 1 0 0-2.665 1.333 1.333 0 0 0 0 2.665z"
              fill="url(#cc)"
            />
            <defs>
              <linearGradient
                id="ca"
                x1="15.662"
                y1="48.339"
                x2="48.338"
                y2="15.661"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC107" />
                <stop offset=".507" stop-color="#F44336" />
                <stop offset=".99" stop-color="#9C27B0" />
              </linearGradient>
              <linearGradient
                id="cb"
                x1="24.929"
                y1="39.071"
                x2="39.071"
                y2="24.929"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC107" />
                <stop offset=".507" stop-color="#F44336" />
                <stop offset=".99" stop-color="#9C27B0" />
              </linearGradient>
              <linearGradient
                id="cc"
                x1="41.808"
                y1="22.192"
                x2="43.692"
                y2="20.308"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC107" />
                <stop offset=".507" stop-color="#F44336" />
                <stop offset=".99" stop-color="#9C27B0" />
              </linearGradient>
            </defs>
          </svg>
        </a>
        <div
          :class="{
            'frisbuy-sr-navigation-button': true,
            'frisbuy-to-hide': !canNavigatePrev,
          }"
          :style="{
            display:
              settings.censorship.hide_ig &&
              isTablet &&
              settings.widget.inlineDesktop == 0
                ? 'block'
                : undefined,
          }"
          @click="navigate(-1)"
        >
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44 36.586L32.708 25.294 32 24.587l-.706.707-11.292 11.292L21.416 38 32 27.415 42.587 38 44 36.586z"
              fill="#262626"
            />
          </svg>
        </div>
        <div
          class="frisbuy-sr-stories"
          :style="{ ...formatSizeCompute }"
          ref="albumList"
        >
          <div
            class="frisbuy-sr-story"
            :style="
              settings.widget.inlineDesktop == 1 && {
                '--fr-story-margin-desktop': `${settings.stories_margin || 0}px`,
                '--fr-story-margin-mobile':
                  `${settings.stories_margin_mob || 0}px`,
              }
            "
            v-for="album in albums"
            :key="album.id"
            @click="selectAlbum(album, $event)"
          >
            <div
              :class="{
                'frisbuy-sr-story-wrapper': true,
                'frisbuy-story-square': isSquare,
                'frisbuy-story-vertical-rectangle': isVerticalRectangle,
                'frisbuy-sr-visited': isVisitedAllPostsInAlbum(album),
                'frisbuy-sr-selected':
                  selectedAlbum && album.id == selectedAlbum.id,
              }"
              :style="{
                background: !isVisitedAllPostsInAlbum(album) && borderColor,
              }"
            >
              <div
                class="frisbuy-sr-story-image"
                :style="{ 'background-image': `url(${album.coverUrl})` }"
                ref="album"
              >
                <img
                  ref="image"
                  :src="getDomainSubstitute(album.coverUrl)"
                  @error="errorImageHandler"
                />
              </div>
            </div>

            <span
              class="frisbuy-sr-story-album-text"
              :style="{
                fontSize: `${settings.highlights_names_fontSize}px`,
                marginTop: `${settings.highlights_names_marginTop}px`,
                color: settings.highlights_names_color,
                fontWeight: settings.highlights_names_fontWeight,
                fontStyle: settings.highlights_names_fontStyle,
                textDecoration: settings.highlights_names_textDecoration,
                fontFamily: settings.highlights_names_fontFamily,
              }"
              v-if="
                settings.stories_highlights_names == 1 &&
                settings.widget.inlineDesktop == 1
              "
              >{{ album.name }}</span
            >
          </div>
        </div>
        <div
          :class="{
            'frisbuy-sr-navigation-button': true,
            'frisbuy-disabled': canNavigateNext,
          }"
          @click="navigate(1)"
        >
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44 26.414L32.708 37.706l-.707.707-.706-.707-11.292-11.292L21.416 25 32 35.585 42.587 25 44 26.414z"
              fill="#262626"
            />
          </svg>
        </div>
        <a
          class="frisbuy-sr-branding"
          target="_blank"
          v-if="!settings.widget.hideBrand && !isTablet"
          :href="`https://frisbuy.ru/s/frisbuystories/?utm_source=stories&utm_medium=referral&utm_campaign=${settings.customerCode}`"
        >
          <span>
            powered by
            <svg
              width="51"
              height="14"
              viewBox="0 0 51 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.7">
                <path
                  d="M46.1607 0C48.6476 0 50.6627 1.98965 50.6627 4.4367C50.6627 6.88375 48.6437 8.8734 46.1607 8.8734C43.6738 8.8734 41.6587 6.88375 41.6587 4.4367C41.6587 1.98965 43.6776 0 46.1607 0Z"
                  fill="currentColor"
                />
                <path
                  d="M46.161 1.38721C47.8705 1.38721 49.259 2.75557 49.259 4.4403C49.259 6.12502 47.8705 7.49339 46.161 7.49339C44.4515 7.49339 43.063 6.12502 43.063 4.4403C43.063 2.75557 44.4515 1.38721 46.161 1.38721Z"
                  fill="white"
                />
                <path
                  d="M46.1607 1.8335C47.6188 1.8335 48.8023 2.99984 48.8023 4.43682C48.8023 5.87379 47.6188 7.04014 46.1607 7.04014C44.7026 7.04014 43.519 5.87379 43.519 4.43682C43.519 2.99984 44.7026 1.8335 46.1607 1.8335Z"
                  fill="currentColor"
                />
                <path
                  d="M34.3334 7.26106V7.29917C34.3334 8.47315 35.2501 9.42605 36.3833 9.42605H36.3949H36.4065C37.5398 9.42605 38.4564 8.47696 38.4564 7.29917V7.26106H38.468V4.40998H39.5355V10.741C39.5355 12.5363 38.1238 14 36.3911 14C36.2712 14 36.1513 13.9923 36.0352 13.9771V12.8298C36.1551 12.8527 36.2789 12.8641 36.4065 12.8641C37.5398 12.8641 38.4564 11.915 38.4564 10.7372V10.6991H38.468V9.74622C37.9149 10.2532 37.1878 10.5619 36.3949 10.5619C34.6661 10.5619 33.2544 9.09444 33.2544 7.30299V4.41379H34.3218V7.26487H34.3334V7.26106ZM26.95 7.26106H26.9616V7.29917C26.9616 8.47315 27.8783 9.42605 29.0115 9.42605H29.0231H29.0347C30.1679 9.42605 31.0846 8.47696 31.0846 7.29917V7.26106H31.0962V4.40998H32.1637V7.29917C32.1637 9.09444 30.752 10.5581 29.0231 10.5581C27.2943 10.5581 25.8826 9.09063 25.8826 7.29917V4.40998H26.95V7.26106ZM16.5189 10.5505H13.4325V9.50228H16.5189C16.7703 9.50228 16.9443 9.41461 17.0333 9.30408C17.0836 9.24309 17.1068 9.15542 17.1222 9.07157C17.1338 8.97247 17.1106 8.86193 17.072 8.76283C16.9714 8.53032 16.7471 8.30544 16.3835 8.1949L16.1708 8.14535L14.9099 7.82518L14.8867 7.81374C14.1635 7.6041 13.6993 7.13528 13.4866 6.6169C13.3861 6.35771 13.3474 6.08709 13.3745 5.81646C13.3977 5.5344 13.4982 5.27522 13.6761 5.05414C13.9623 4.68442 14.4265 4.43666 15.0376 4.43666H17.7681V5.48485H15.0492C14.7978 5.48485 14.6237 5.57252 14.5348 5.68306C14.4845 5.74404 14.4613 5.83171 14.4458 5.91556C14.4342 6.01467 14.4574 6.11377 14.4961 6.2243C14.5966 6.45681 14.821 6.6817 15.1845 6.79223L15.3973 6.84178L16.6581 7.16196L16.6813 7.17339C17.393 7.38303 17.8571 7.85186 18.0698 8.37023C18.1704 8.62942 18.2091 8.91148 18.182 9.17067C18.1588 9.45273 18.0582 9.71192 17.8803 9.93299C17.5941 10.3027 17.1416 10.5505 16.5189 10.5505ZM12.102 10.5505H11.0384V4.46716C11.2086 4.45572 11.3787 4.4481 11.5528 4.4481H12.102V10.5505ZM6.7259 10.5505H5.66229V5.49629V4.4481H6.7259V5.26759C7.27898 4.75684 7.94809 4.45953 8.80285 4.4481H8.80672C9.13934 4.45191 9.47196 4.4481 9.80458 4.49765V5.58777C9.61507 5.55346 9.41008 5.53822 9.20122 5.53822C8.93822 5.53822 8.69069 5.5649 8.46636 5.61445C7.48784 5.77835 6.73751 6.65501 6.73751 7.71083L6.7259 8.10723V10.5505ZM19.9805 4.45191H22.0071C23.7089 4.45191 25.0935 5.82027 25.109 7.48213C25.109 9.17067 23.7205 10.539 22.0226 10.539C20.3208 10.539 18.9362 9.17067 18.9362 7.49738L18.9246 4.44048V2.00486H19.9882L19.9805 4.45191ZM2.13883 10.5238H1.07522V5.48485H0V4.43666H1.05588V3.55237C1.05588 1.75711 2.46758 0.293457 4.20031 0.293457C4.3202 0.293457 4.4401 0.30108 4.55613 0.316327V1.46362C4.43624 1.44075 4.31247 1.42931 4.18484 1.42931C3.0516 1.42931 2.12723 2.3784 2.12723 3.55619L2.13496 4.45191H4.40143V5.5001H2.13883V10.5238ZM21.9685 5.51154V5.5001H19.9805V7.45926H19.9921C19.9921 7.4707 19.9921 7.48213 19.9921 7.49738C19.9921 8.59512 20.8932 9.47941 22.0033 9.47941C23.1133 9.47941 24.0145 8.59131 24.0145 7.49738C24.0145 6.39964 23.1133 5.51535 22.0033 5.51535H21.9685V5.51154ZM11.5528 2.00486C11.2008 2.00486 10.9107 2.29073 10.9107 2.63759C10.9107 3.02637 11.2704 3.33511 11.6804 3.25507C11.9279 3.20933 12.1291 3.01113 12.1793 2.76337C12.2606 2.36315 11.9473 2.00486 11.5528 2.00486Z"
                  fill="currentColor"
                />
              </g>
            </svg>
          </span>
        </a>
      </div>
    </div>

    <PreviewStory
      v-if="selectedAlbum"
      :settings="settings"
      :album="selectedAlbum"
      :albums="albums"
      @set-album="selectAlbum"
      @set-story="selectStory"
      @close-preview="closePreview"
      ref="PreviewStory"
    ></PreviewStory>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// TODO: remove "body-scroll-lock" lib from project. Use func `lockWindowScroll` to block page scrolling
import { clearAllBodyScrollLocks } from "body-scroll-lock";
// Components
import PreviewStory from "./PreviewStory.vue";
// Mixins
import analytics from "../common/mixins/analytics";
import elementInView from "../common/mixins/elementInView";
// Consts
import STORIES_CONSTS from "@/common/consts/stories.js";
// Services
import {
  deleteParamFromHash,
  getValueFromHashParam,
  setHashParam,
} from "@/services/urlHashParam";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  components: {
    PreviewStory,
  },

  mixins: [analytics, elementInView],

  props: ["propSettings", "albums"],
  data() {
    return {
      settings: this.propSettings || {},
      isTablet: false,
      selectedAlbum: null,
      hadSeen: false,
      visitedPosts: JSON.parse(localStorage.getItem("visitedPosts") || "[]"),
      labelItemPosition: [
        "fbProduct",
        "igCode",
        "link",
        "linklabel",
        "offer",
        "swipeType",
      ],
      categoryPostfix: "SR",
      canNavigatePrev: false,
      canNavigateNext: false,
      isArrowsDisplayed:
        this.propSettings.widget.showScrollArrows == 1 &&
        window.innerWidth > 459,
      isMobileLandscape: false,
    };
  },

  computed: {
    widgetRefElement() {
      return this.$refs["frisbuy-widget-highlights"];
    },

    isInline() {
      const { widget } = this.settings;

      return widget && (widget.inlineDesktop == "1" || this.isMobileLandscape);
    },

    paddings() {
      const { widget } = this.settings;

      if (this.isInline) {
        if (widget.paddings) {
          return widget.paddings;
        }
      }

      return {
        top: undefined,
        bottom: undefined,
        left: undefined,
        right: undefined,
      };
    },

    backgroundColor() {
      const { widget } = this.settings;

      if (this.isInline) {
        if (widget.backgroundColor) {
          return widget.backgroundColor;
        }
      }

      return undefined;
    },

    borderColor() {
      const { widget } = this.settings;

      if (this.isInline) {
        if (widget.borderColor) {
          return widget.borderColor;
        }
      }

      return undefined;
    },

    isSquare() {
      if (!this.isInline) return false;

      return this.settings.widget.shape === STORIES_CONSTS.SHAPE_TYPES.SQUARE;
    },

    isVerticalRectangle() {
      return (
        this.isInline &&
        this.settings.widget.shape ===
          STORIES_CONSTS.SHAPE_TYPES.VERTICAL_RECTANGLE
      );
    },

    formatSizeCompute() {
      // padding сториса
      const wrapperPaddingSize = 2;
      // Пропорции прямоугольного формата
      const aspectRatio = 9 / 16;
      // Дефолтный размер сторис
      const defaultStorySize = 60;

      // Если включен кастомный размер сторис и не включен фиксированный режим
      if (
        this.settings.isCustomSize == "1" &&
        this.settings.widget.inlineDesktop == "1"
      ) {
        return {
          // Размеры для desktop circle
          "--frisbuy-desktop-size": this.settings.pcSize
            ? this.settings.pcSize + "px"
            : `${defaultStorySize}px`,
          // Размеры для mobile circle
          "--frisbuy-mobile-size": this.settings.mobileSize
            ? this.settings.mobileSize + "px"
            : `${defaultStorySize}px`,
          // Размеры для паддинга
          "--frisbuy-story-wrapper-padding": wrapperPaddingSize + "px",
          // Размеры для desktop rectangle. На мобилке он кружками
          "--frisbuy-rectangle-size":
            Math.round(
              ((Number(this.settings.pcSize) || defaultStorySize) +
                wrapperPaddingSize * 2) /
                aspectRatio
            ) + "px",
        };
      }

      // Дефолтный размеры всех форматов сторис
      return {
        "--frisbuy-desktop-size": `${defaultStorySize}px`,
        "--frisbuy-mobile-size": `${defaultStorySize}px`,
        "--frisbuy-story-wrapper-padding": wrapperPaddingSize + "px",
        "--frisbuy-rectangle-size":
          Math.round(
            (defaultStorySize + wrapperPaddingSize * 2) / aspectRatio
          ) + "px",
      };
    },

    isMobileOnly() {
      return (
        (this.settings.mobileOnly == 1 ||
          typeof this.settings.mobileOnly === "undefined") &&
        this.settings.desktopOnly == 0
      );
    },

    isDesktopOnly() {
      return (
        (this.settings.desktopOnly == 1 ||
          typeof this.settings.desktopOnly === "undefined") &&
        this.settings.mobileOnly == 0
      );
    },
  },

  watch: {
    selectedAlbum(album) {
      if (!album) {
        const hashName = "fri_story_id";
        deleteParamFromHash(hashName);
      }
    },
  },

  beforeMount() {
    const { script: scriptCode } = this.settings.widget;

    if (scriptCode) {
      const head = document.querySelector("head");
      const script = document.createElement("script");

      script.type = "text/javascript";

      try {
        script.appendChild(document.createTextNode(scriptCode));
      } catch (e) {
        script.text = scriptCode;
      }

      head.insertBefore(script, head.firstChild);
    }
  },

  mounted() {
    this.updateIsTableValue();

    this.$nextTick(() => {
      this.selectPostByLinkHash();
    });

    const { scrollHandler } = this;

    scrollHandler();
    window.addEventListener("scroll", scrollHandler);
    window.addEventListener("message", this.postMessageHandler);

    (function (timer) {
      const scrollElement = document.querySelector(".frisbuy-sr-block");
      scrollElement.addEventListener("scroll", function () {
        (function (el) {
          el.classList.add("frisbuy-is-scrolling");
          clearTimeout(timer);
          timer = setTimeout(function () {
            el.classList.remove("frisbuy-is-scrolling");
          }, 100);
        })(scrollElement);
      });
    })();

    this.$nextTick(() => {
      const { $refs, storiesScroll } = this;
      const { albumList } = $refs;

      storiesScroll();
      albumList.addEventListener("scroll", storiesScroll);
    });
  },

  created() {
    this.sendAnalyticEvent("Load", location.href, true, true);
    window.addEventListener("resize", this.handleViewportResize);
    window.addEventListener("hashchange", this.selectPostByLinkHash);
  },

  unmounted() {
    window.removeEventListener("resize", this.handleViewportResize);
    window.removeEventListener("message", this.postMessageHandler);
    window.removeEventListener("hashchange", this.selectPostByLinkHash);
  },

  methods: {
    isVisitedAllPostsInAlbum(album) {
      let isVisited = true;

      for (let i = 0; i < album.posts.length; i++) {
        const post = album.posts[i].frisbuyPost;

        if (!this.visitedPosts.includes(post.id)) {
          isVisited = false;
          break;
        }
      }

      return isVisited;
    },

    navigate(direction) {
      const { albumList } = this.$refs;

      if (!albumList) return;

      albumList.scrollBy(
        0,
        albumList.firstElementChild.offsetHeight * direction
      );

      this.sendAnalyticEvent("Swipe", { swipeType: "arrow" });
    },

    setStoryToHashParams(albumId, postIndex, postId) {
      if (
        this.settings["popup_update_url"] &&
        this.settings["popup_update_url"] === "0"
      ) {
        return;
      }

      const hashName = "fri_story_id";
      const storyHashValue = `${albumId}-${postIndex}-${postId}`;

      setHashParam(hashName, storyHashValue);
    },

    selectPostByLinkHash() {
      const hashName = "fri_story_id";
      const hashValue = getValueFromHashParam(hashName);

      if (!hashValue) {
        return;
      }

      const albumId = Number(hashValue.split("-")[0]);
      const postIndex = Number(hashValue.split("-")[1] || 0);
      const albumByIndex = this.albums.find((album) => album.id === albumId);

      if (!albumByIndex) {
        return;
      }

      if (!this.selectedAlbum) {
        this.selectAlbum(albumByIndex);
      }

      if (postIndex !== 0) {
        this.selectStory(postIndex);
      }
    },

    selectAlbum(album, event) {
      this.selectedAlbum = album;

      if (
        !album.runningPostIndex ||
        (album.isAllStoriesWatched && event?.type === "click")
      ) {
        this.selectedAlbum.runningPostIndex = 0;
        this.selectedAlbum.isAllStoriesWatched = false;
      }

      const storyIndex = album.runningPostIndex || 0;
      const story = album.posts[storyIndex];
      const postId =
        story.instagramPost?.frisbuyId || story.providerPost?.frisbuyId;

      this.setStoryToHashParams(album.id, storyIndex, postId);

      const visitedPost = story.frisbuyPost;
      this.setPostAsVisited(visitedPost.id);

      // [start] send analytic
      if (event) {
        this.sendAnalyticEvent("ClickPic", {
          provPostId:
            story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
          fbProduct: story.frisbuyPost.id,
          igCode: story.providerPost
            ? story.providerPost.shortcode
            : story.instagramPost.shortcode,
        });
      }

      this.sendAnalyticEvent("ViewPic", {
        provPostId:
          story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
        fbProduct: story.frisbuyPost.id,
        igCode: story.providerPost
          ? story.providerPost.shortcode
          : story.instagramPost.shortcode,
      });
      // [end] send analytic
    },

    setPostAsVisited(postId) {
      if (!this.visitedPosts.includes(postId)) {
        this.visitedPosts.push(postId);
        localStorage.setItem("visitedPosts", JSON.stringify(this.visitedPosts));
      }
    },

    async selectStory(index) {
      if (index > this.selectedAlbum.posts.length - 1) {
        await this.updatePosts();
      }

      if (index > this.selectedAlbum.posts.length - 1) {
        console.error(`undefined posts index: ${index}`);
        this.closePreview();

        return;
      }

      let storyIndex = index;

      if (!this.selectedAlbum || isNaN(this.selectedAlbum.runningPostIndex)) {
        return;
      }

      if (storyIndex > this.selectedAlbum.postCount - 1) {
        storyIndex = this.selectedAlbum.postCount - 1;
      } else if (storyIndex < 0) {
        storyIndex = 0;
      }

      this.selectedAlbum.runningPostIndex = storyIndex;

      const visitedPost = this.selectedAlbum.posts[index].frisbuyPost;
      this.setPostAsVisited(visitedPost.id);

      const story = this.selectedAlbum.posts[storyIndex];
      const postId =
        story.instagramPost?.frisbuyId || story.providerPost?.frisbuyId;

      this.setStoryToHashParams(this.selectedAlbum.id, storyIndex, postId);

      // [start] send analytic
      this.sendAnalyticEvent("ViewPic", {
        provPostId:
          story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
        fbProduct: story.frisbuyPost.id,
        igCode: story.providerPost
          ? story.providerPost.shortcode
          : story.instagramPost.shortcode,
      });
      // [end] send analytic
    },

    async fetchPosts(url) {
      const { selectedAlbum, settings } = this;
      const { per_page } = settings;

      const maxPosts = window.parseInt(per_page) || 20;

      try {
        const response = await axios.get(url);

        const { posts, lastPage } = response.data;

        if (posts && posts.length) {
          if (posts.length >= maxPosts) {
            selectedAlbum.posts.push(...posts.slice(0, maxPosts));

            selectedAlbum.lastPage = true;
          } else {
            selectedAlbum.posts.push(...posts);

            selectedAlbum.lastPage = lastPage;
          }
        }
      } catch (e) {
        const safeDelayForRetryFetch = 5000;

        setTimeout(() => {
          if (this.currentCountRetryFetchPosts < this.maxCountRetryFetchPosts) {
            this.currentCountRetryFetchPosts++;
            this.fetchPosts(url);
          } else {
            this.currentCountRetryFetchPosts = 0;
            this.switchToNext(1);
          }
        }, safeDelayForRetryFetch);
      }
    },

    async updatePosts() {
      const { settings, selectedAlbum } = this;

      if (selectedAlbum.lastPage) return;

      const lastPost = selectedAlbum.posts[selectedAlbum.posts.length - 1];

      let frisbuyPostId = null;

      if (lastPost.instagramPost) {
        frisbuyPostId = lastPost.instagramPost.frisbuyId;
      }

      if (lastPost.providerPost) {
        frisbuyPostId = lastPost.providerPost.frisbuyId;
      }

      if (!frisbuyPostId) return;

      const { srcDomain, embedId } = settings;

      const url = `${srcDomain}/fb/widget?embed_id=${embedId}&stories_highlight_album_id=${selectedAlbum.id}&last_post_id=${frisbuyPostId}&data=1`;

      await this.fetchPosts(url);
    },

    closePreview() {
      this.$refs.PreviewStory.stopPreview();
      this.selectedAlbum = null;

      clearAllBodyScrollLocks();
    },

    scrollHandler() {
      this.$nextTick(() => {
        const { isElementInView, sendAnalyticEvent, hadSeen, $el } = this;

        if (!hadSeen && isElementInView($el, true)) {
          this.hadSeen = true;
          sendAnalyticEvent("Eyesight", location.href, true, true);
        }
      });
    },

    storiesScroll() {
      const { albumList } = this.$refs;

      this.canNavigatePrev = albumList.scrollTop;
      this.canNavigateNext = !(
        albumList.scrollHeight > albumList.offsetHeight &&
        albumList.scrollTop < albumList.scrollHeight - albumList.offsetHeight
      );
    },

    slideHandler(direction) {
      const scrollElement =
        this.widgetRefElement.querySelector(".frisbuy-sr-block");
      const widthElement =
        this.widgetRefElement.querySelectorAll(".frisbuy-sr-story")[1];

      scrollElement.scrollBy = (elementWidth) => {
        scrollElement.scrollLeft = scrollElement.scrollLeft + elementWidth;
      };

      scrollElement.scrollBy(widthElement.clientWidth * direction, 0);
    },

    updateIsTableValue() {
      this.isTablet =
        Math.min(window.innerWidth, screen.width) < 568 &&
        Math.min(window.innerHeight, screen.height) < 426;
    },

    handleViewportResize() {
      this.updateIsTableValue();

      this.isMobileLandscape = false;

      if (window.innerWidth > 479 && window.innerHeight < 416) {
        this.isMobileLandscape = true;
      }

      if (
        this.settings.widget.showScrollArrows == 1 &&
        window.innerWidth > 459
      ) {
        this.isArrowsDisplayed = true;
      } else {
        this.isArrowsDisplayed = false;
      }
    },

    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e) {
      MediaCatcher(e, 2, widgetTypes.HIGHLIGHTS);
    },

    updateSettings(path, value) {
      const nodes = path.split(".");
      const settingsType = nodes.shift();
      const lastNode = nodes[nodes.length - 1];

      let source = nodes.reduce((source, node) => {
        if (node === lastNode) return source;

        if (!source || !Object.hasOwn(source, node)) return;
        return source[node];
      }, this[settingsType]);

      if (!source) return console.error("Can't find source by path.");

      source[lastNode] = value;
    },

    postMessageHandler(event) {
      const { data } = event;

      if (
        !event.origin.includes("frisbuy") ||
        !data ||
        !Object.hasOwn(data, "property")
      )
        return;

      this.$nextTick(() => {
        this.updateSettings(data.property, data.value);
      });
    },
  },
};
</script>
<style lang="scss">
@import "../common/style/mixins.scss";

@keyframes slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-reverse {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes story-slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(49px);
  }
}

@keyframes story-slide-reverse {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-49px);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.frisbuy-sr-widget {
  font-family: "Gotham Pro", sans-serif;
  border-radius: 0 16px 16px 0;
  height: 512px;
  position: fixed;
  left: 0;
  width: 80px;
  top: calc(50% - 256px);
  box-sizing: border-box;
  display: flex;
  transition: width 1s, 1s height 1s, 1s top 1s;
  z-index: 9999999999999;
  transform: translateX(-100%);
  animation: 1s slide forwards;

  .frisbuy-title-block {
    display: none;
  }

  &.frisbuy-sr-right {
    left: auto;
    right: 0;
    transform: translateX(0);
    border-radius: 16px 0 0 16px;
    animation: 1s slide-reverse forwards;

    .frisbuy-sr-block {
      border-radius: 16px 0 0 16px;
    }

    .frisbuy-sr-instagram {
      &.frisbuy-to-hide {
        transform: translateX(100%);
      }
    }

    .frisbuy-sr-story-wrapper {
      &.frisbuy-sr-selected {
        &:before {
          content: "";
          border-width: 5px 5px 5px 0;
          border-color: transparent #222222 transparent transparent;
          left: auto;
          right: 100%;
        }
      }
    }
  }

  &.frisbuy-has-selected {
    height: 656px;
    top: calc(50% - 328px);
    transition: height 1s, top 1s, 1s width 1s;

    .frisbuy-sr-block {
      border-radius: 0;
      box-shadow: none;
      transition: 2s box-shadow 0s;
    }
  }

  &.frisbuy-sr-inline {
    position: static;
    box-shadow: none;
    border-radius: 0;
    width: 100%;
    display: block !important;
    max-width: 100%;
    height: auto;
    animation: none;
    transform: none;

    &.frisbuy-has-selected {
      height: auto;
      width: auto;
      transition: none;
      animation: none;
    }

    .frisbuy-title-block {
      display: block;
    }

    .frisbuy-sr-block {
      flex-direction: row;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      background-color: transparent;
      box-shadow: none;
      scroll-behavior: smooth;

      &-wrapper {
        position: relative;

        .frisbuy-sr-block {
          overflow-x: hidden;
        }

        .frisbuy-sr-arrow {
          position: absolute;
          z-index: 3;
          height: 100%;
          display: flex;
          align-items: center;
          padding-bottom: 15px;
          overflow: scroll;
        }
      }

      &.frisbuy-is-scrolling {
        &::-webkit-scrollbar-thumb {
          background: #717171;
        }
      }

      &::-webkit-scrollbar {
        width: 2px;
        height: 3px;
      }
      &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
      }
      &::-webkit-scrollbar-thumb {
        border: 0px none transparent;
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb:hover,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-thumb:active {
        background: #222222;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        border: none;
      }
      &::-webkit-scrollbar-track:hover,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-track:active,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-corner {
        background: transparent;
      }

      .frisbuy-sr-branding {
        display: none;
      }
    }

    .frisbuy-sr-navigation-button,
    .frisbuy-sr-instagram {
      display: none;
    }

    .frisbuy-sr-stories {
      display: flex;
      overflow: visible;
      justify-content: center;
    }

    .frisbuy-sr-story {
      padding-top: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      margin-right: var(--fr-story-margin-desktop, 0);

      @media screen and (max-width: 767px) {
        margin-right: var(--fr-story-margin-mobile, 0);
      }

      &:not(:first-child) {
        padding-left: 8px;
      }

      &:last-child {
        margin: 0 !important;
      }
    }
  }

  * {
    box-sizing: border-box;
  }

  .frisbuy-sr-block {
    display: flex;
    padding: 8px 0;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    height: 100%;
    position: relative;
    background: #fff;
    border-radius: 0 16px 16px 0;
    z-index: 2;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
      0px 4px 16px rgba(0, 0, 0, 0.08);
    transition: 2s box-shadow 0s;

    .frisbuy-sr-branding {
      width: 64px;
      height: 35px;
      flex-shrink: 0;
      font-size: 8px;
      line-height: 9px;
      color: #000000;
      opacity: 0.5;
      text-decoration: none;
      text-align: center;

      // span {
      //   display: flex;
      //   align-items: center;
      // }

      svg {
        margin-top: 4px;
      }
    }
  }

  .frisbuy-sr-instagram,
  .frisbuy-sr-navigation-button {
    flex-shrink: 0;
  }

  .frisbuy-to-hide {
    transition: opacity 0.3s, transform 0.3s;
  }

  .frisbuy-sr-instagram {
    top: 8px;
    left: 8px;
    position: absolute;
    transition: opacity 0.2s, transform 0.3s;

    &.frisbuy-to-hide {
      opacity: 0;
      pointer-events: none;
      transform: translateX(-100%);
    }
  }

  .frisbuy-sr-navigation-button {
    transition: opacity 0.2s, transform 0.3s;
    width: 64px;
    height: 64px;
    cursor: pointer;

    &.frisbuy-to-hide {
      display: none;
      pointer-events: none;
    }

    &.frisbuy-disabled {
      opacity: 0.1;
      pointer-events: none;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .frisbuy-sr-stories {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0 8px;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;

    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
  }

  .frisbuy-sr-story {
    padding-top: 8px;

    .frisbuy-sr-story-wrapper {
      padding: var(--frisbuy-story-wrapper-padding);

      /* Custom size section - start */

      // Rectangle 767-
      &.frisbuy-story-vertical-rectangle {
        width: calc(
          var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
        );
        height: calc(
          var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
        );
      }

      // Circle/square 767+
      width: calc(
        var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
      );
      height: calc(
        var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
      );

      // Circle/square light 767+
      &:after {
        width: calc(
          var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
        );
        height: calc(
          var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
        );
      }

      @media screen and (max-width: 767px) {
        // Circle/square 767-
        width: calc(
          var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
        );
        height: calc(
          var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
        );

        // Circle/square light 767-
        &:after {
          width: calc(
            var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) *
              2
          );
          height: calc(
            var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) *
              2
          );
        }
      }

      // Circle/square light 768+
      @media screen and (min-width: 768px) {
        &.frisbuy-story-vertical-rectangle {
          width: calc(
            var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) *
              2
          );
          height: var(--frisbuy-rectangle-size);
        }
      }

      /* Custom size section - end */
    }

    &:first-child .frisbuy-sr-story-wrapper {
      position: relative;

      &.frisbuy-story-square {
        &:after {
          content: initial !important;
        }
      }

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgB7dJBDcMwEETRdREUQsqgEMKkLZIWQhkUSiEEQiiEgbOR1pIT5ZaLR/lPsiz7NBqNGY7JOXemxkM//Yx+HqYkQmep4NH2Yqzev+ans52JVPulXb/fm/Z7lfb/EbyPd2n/Y62rQq/al+GBhwh+X6YS7XemYGcyX1NRT8bPtfxfrH23uF8ppcmUlMkAAAAAAAAAAHB2MwGEt//dwcuSAAAAAElFTkSuQmCC");
        background-position: center;
        background-size: contain;
        border-radius: 100%;
        transform-origin: 50% 50%;
        animation: 6.5s spin 2s infinite;
      }
    }
  }

  .frisbuy-sr-story-wrapper {
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    );
    border-radius: 50%;
    flex-shrink: 0;
    cursor: pointer;

    &.frisbuy-story-square {
      border-radius: inherit;

      & > div {
        border-radius: inherit;
      }
    }

    &.frisbuy-story-vertical-rectangle {
      @media screen and (min-width: 768px) {
        border-radius: 5%;

        .frisbuy-sr-story-image {
          border-radius: 4%;
        }
      }

      &:after {
        display: none;
      }
    }

    &:hover {
      opacity: 0.8;
    }

    &.frisbuy-sr-visited {
      background: transparent !important;
    }

    &.frisbuy-sr-selected {
      position: relative;

      &:before {
        content: "";
        position: absolute;
        display: block;
        border-width: 5px 0 5px 5px;
        border-style: solid;
        border-color: transparent transparent transparent #222222;
        left: 100%;
        top: calc(50% - 5px);
      }
    }
  }

  .frisbuy-sr-story-image {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    background-size: cover;
    background-position: center;
    border: 2px solid #fff;
    overflow: hidden;

    img,
    video {
      opacity: 0;
      pointer-events: none;
    }
  }

  @include screen-xs {
    &:not(.frisbuy-sr-mobile-fixed) {
      position: static;
      box-shadow: none;
      border-radius: 0;
      width: 100%;
      display: block;
      max-width: 100%;
      height: auto;
      animation: none;
      transform: none;

      &.frisbuy-has-selected {
        height: auto;
        width: auto;
        transition: none;
        animation: none;
      }

      .frisbuy-title-block {
        display: block;
      }

      .frisbuy-sr-block {
        flex-direction: row;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        background-color: transparent;
        box-shadow: none;
      }

      .frisbuy-sr-navigation-button,
      .frisbuy-sr-instagram {
        display: none;
      }

      .frisbuy-sr-stories {
        display: flex;
        overflow: visible;
      }

      .frisbuy-sr-story {
        padding-top: 0;

        &:not(:first-child) {
          padding-left: 8px;
        }
      }
    }

    &.frisbuy-sr-mobile-fixed {
      bottom: 50px;
      top: auto;
      height: 56px;
      width: 74px;

      &.frisbuy-sr-right {
        border-radius: 56px 0 0 56px;

        .frisbuy-sr-block {
          border-radius: 56px 0 0 56px;
          flex-direction: row;
          overflow: hidden;
        }

        .frisbuy-sr-stories {
          flex-direction: row;
          flex-shrink: 0;
          animation: 1s story-slide-reverse 1s forwards;
          margin-left: 0;
        }

        .frisbuy-sr-story {
          padding: 0 7px 0 0;
        }

        .frisbuy-sr-instagram {
          animation: 1s story-slide-reverse 1s forwards;
        }
      }

      &.frisbuy-has-selected {
        height: auto;
        width: auto;
        transition: none;
        transform: none;
        animation: none;
      }

      .frisbuy-sr-navigation-button {
        display: none;
      }

      .frisbuy-sr-instagram {
        position: static;
        flex-shrink: 0;
        height: 56px;
        animation: 1s story-slide 1s forwards;

        svg {
          height: 56px;
          width: 56px;
        }
      }

      .frisbuy-sr-block {
        display: flex;
        flex-direction: row-reverse;
        // align-items: center;
        // justify-content: center;
        overflow: hidden;
        padding: 0;
        height: 56px;
        width: 74px;
        max-width: 74px;
        border-radius: 0 56px 56px 0;
        transition: none;
      }

      .frisbuy-sr-stories {
        display: flex;
        flex-direction: row-reverse;
        width: 74px;
        margin-left: -49px;
        padding: 0;
        animation: 1s story-slide 1s forwards;
      }

      .frisbuy-sr-story {
        padding: 0 0 0 7px;

        &:first-child .frisbuy-sr-story-wrapper {
          &:after {
            width: 46px;
            height: 46px;
          }
        }
      }

      .frisbuy-sr-story-wrapper {
        width: 46px;
        height: 46px;
      }

      .frisbuy-preview-story {
        transition: unset;

        &:before {
          display: none;
        }
      }
    }
  }

  @media (max-height: 700px) and (min-width: 768px) {
    height: 448px;
    width: 70px;
    top: calc(50% - 224px);

    &.frisbuy-has-selected {
      height: 574px;
      top: calc(50% - 287px);
    }

    .frisbuy-sr-block {
      padding: 7px 0;
    }

    .frisbuy-sr-instagram {
      top: 7px;
      left: 7px;
      width: 56px;
      height: 56px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .frisbuy-sr-navigation-button {
      width: 56px;
      height: 56px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .frisbuy-sr-stories {
      padding: 0 7px;
    }

    .frisbuy-sr-story {
      padding-top: 7px;
    }

    .frisbuy-sr-story-wrapper {
      width: 56px;
      height: 56px;
    }
  }

  &.frisbuy-mobile-only {
    @media screen and (min-width: 768px) {
      display: none !important;
    }
  }

  &.frisbuy-desktop-only {
    @media screen and (max-width: 768px) {
      display: none !important;
    }
  }
}
.frisbuy-sr-story-album-text {
  max-width: 56px;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
